import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13","key":"svg-0"}],["path",{"d":"M8 16l-4 -4l4 -4","key":"svg-1"}]]

const IconArrowLoopLeft2 = createReactComponent('outline', 'arrow-loop-left-2', 'ArrowLoopLeft2', __iconNode);

export default IconArrowLoopLeft2;